// extracted by mini-css-extract-plugin
export default {"box":"arrow_box_Z4fIt","arrowTop":"arrow_arrowTop_K2Mz-","arrowBottom":"arrow_arrowBottom_H-SiX","highlight":"arrow_highlight_UcAcV"};